import axios from "axios";
// import VueAxios from "vue-axios";
import qs from "qs";
import router from '@/router/index'

// window.use(VueAxios, axios);
window.axios = axios
window.axios.defaults.timeout = 3600 * 60;
if (process.env.NODE_ENV === "development") {
  window.axios.defaults.baseURL = "http://10.10.109.103:5566/saas/api/v1";
} else {
  window.axios.defaults.baseURL = "/saas/api/v1";
}
window.axios.defaults.withCredentials = true;

window.axios.interceptors.request.use(
  config => {
    if (config.url.indexOf('/api/user/login') === -1) {
      let token = window.localStorage.getItem('Authorization')
      if (token) {
        config.headers['Authorization'] = token
      }
    }

    return config
  },
  error => {}
)

axios.interceptors.response.use(
  res => {
    let data = res.data || {}
    let code = data.code || ''
    if (code == 10000) {
      let location = window.location
      window.location.replace(location.origin + '/saas/account/login')
      router.replace('/account/login')
    }
    return res
  },
  err => {}
)

export const fetch = (url, timeout) => {
  return window.axios({
    method: "get",
    url: url,
    timeout,
  })
    .then(function (response) {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.statusText || error.message);
    });
};
export const fetchPost = (url, params = {}, headers = { "Content-Type": "application/x-www-form-urlencoded" }) => {
  if (headers && headers["Content-Type"] != "application/json") {
    params = qs.stringify(params)
  }
  return window.axios({
    method: "post",
    url,
    headers,
    data: params,
  })
    .then(function (response) {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.statusText);
    });
};
export const uploadFile = (url, params = {}, postParams = {}, flag = false) => {
  let data = new FormData();
  // data.append('file', params.file);
  Object.keys(params).forEach((key) => {
    data.append(key, params[key]);
  });
  return window.axios({
    method: "post",
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
    params: postParams,
  })
    .then(function (response) {
      if (flag) {
        return Promise.resolve(response);
      }
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.statusText);
    });
};

export const importUploadFile = (url, params = {}, postParams = "") => {
  let data = new FormData();
  data.append(params.id, params.file);
  if (postParams) {
    for (let key in postParams) {
      data.append(key, postParams[key]);
    }
  }
  return window.axios({
    method: "post",
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  })
    .then(function (response) {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.statusText);
    });
};
